export default "assets/images/icons/linkedin-6c3b4e73.svg";